import { FC } from "react";
import { ConfirmDeleteModal } from "components/confirmDeleteModal";
import { useBucketContext } from "context/bucket";
import { showSuccessToast } from "utils";
import { useAppDispatch } from "redux/store";
import { showErrorModal } from "redux/slices";
import { DeleteModalConfig, ModalProps } from "../types";

export const DeleteModal: FC<ModalProps<DeleteModalConfig>> = (props) => {
  const { config, onClose } = props;
  const { name, path, isFolder, thumbnail } = config ?? {
    name: "",
    path: "",
    isFolder: true,
  };

  const {
    fetchHomePageData,
    deleteFolder,
    deleteFile,
    apiHandler,
    breadcrumb,
  } = useBucketContext();

  const dispatch = useAppDispatch();

  const handleDeleteFolder = async () => {
    if (path) {
      const result = await deleteFolder(path);
      if (result) {
        await fetchHomePageData(breadcrumb);
      }
      return result;
    }
  };

  const handleDeleteFile = async () => {
    if (path) {
      const result = await deleteFile?.(path, thumbnail);
      if (result) {
        await fetchHomePageData(breadcrumb);
      }
      return result;
    }
  };

  const folderDeletion = async () => {
    const result = await apiHandler(handleDeleteFolder);
    if (result) {
      showSuccessToast("Cartella eliminata", "success_folder_delete");
      onClose();
    } else {
      dispatch(
        showErrorModal({ text: "Errore durante l'eliminazione della cartella" })
      );
    }
  };

  const fileDeletion = async () => {
    const result = await apiHandler(handleDeleteFile);
    if (result) {
      showSuccessToast("File eliminato", "success_file_delete");
      onClose();
    } else {
      dispatch(
        showErrorModal({ text: "Errore durante l'eliminazione del file" })
      );
    }
  };

  const confirmDeletion = async () =>
    isFolder ? folderDeletion() : fileDeletion();

  return (
    <ConfirmDeleteModal
      show={Boolean(config)}
      name={name}
      text={`Sei sicuro di voler eliminare ${
        isFolder ? "questa cartella" : "questo file"
      }?`}
      handleCancel={onClose}
      handleConfirm={confirmDeletion}
    />
  );
};
